<template>
  <section class="policy">
    <div 
      class="scroll-y-outer" 
      :style="{
        background: this.disabled ? '#fff' : '#FCF8C2',
        transition: '.3s'
      }"
    >
      <div 
        class="scroll-y-inner"
        ref="policy"
      >
        <div
          v-for="(key, i) in Object.keys(policies)"
          :key="key"
          class="scorll-y-content mb-m"
        >
          <h3 class="mb-s"> {{ policies[key].name }} 
            <span
              v-if="i === 0"
              :style="{color: '#ff6c36'}"
            >(請將下拉式捲軸捲至內容文末)
            </span>
          </h3>
          <p :style="{whiteSpace: 'pre-wrap', lineHeight: '1.8'}">{{ policies[key].content }}</p>
        </div>
      </div>
    </div>
    <Checkbox
      v-model="val"
      v-bind="{disabled}"
      size="large"
    >我已了解上述相關條文
    </Checkbox>
  </section>
</template>

<script>
  import { Checkbox } from 'iview';
  import debounce from '@/utils/debounce';
  import policies from '@/staticData/servicePolicies';

  export default {
    components: { Checkbox },
    props: {
      value: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        policies,
        disabled: true,
        listener: null
      };
    },
    computed: {
      val: {
        get() { return this.value; },
        set(val) { this.$emit('input', val); }
      },
      paragraphStyle() {
        return {
          background: '#ccc'
        };
      }
    },
    created() {
      this.handler = debounce(this.handleScroll, 300);
    },
    mounted() {
      const el = this.$refs.policy;
      el.addEventListener('scroll', this.handler, true);
    },
    beforeDestroy() {
      const el = this.$refs.policy;
      el.removeEventListener('scroll', this.handler, true);
    },
    methods: {
      handleScroll(e) {
        const { scrollHeight, scrollTop, offsetHeight } = e.target;
        if (scrollTop + offsetHeight + 20 > scrollHeight) {
          this.disabled = false;
          return;
        }
        this.disabled = true;
      }
    }
  };
</script>